import ValidationsService from './validationsService';

const ValidationsServiceInstance = new ValidationsService();
export default ValidationsServiceInstance;
